import React from "react";
import HeaderCardEvent from "./headerCardEvent/headerCardEvent";
import BodyCardEvent from "./bodyCardEvent/bodyCardEvent";
import FooterCardEvent from "./footerCardEvent/footerCardEvent";
import "./cardEvent.sass";

export default function CardEvent({ item, flagMomios, indice, longitud, patrocinador }) {

  const patrocinadorMetadata = item[`${patrocinador.toLowerCase()}_metadata`] || {};

  return (
    <>
      <div className={indice + 1 < longitud ? "container-card-evento card-middle" : "container-card-evento"} key={item.id_juego}>
        <HeaderCardEvent nameEvent={item.liga} statusEvent={item.period_title} classEvent={item.class} urlEvent={item.opta_event_url} dateUTC={item.utc_date} />

        <BodyCardEvent
          imgL={item.left_image} 
          momioL={patrocinadorMetadata?.left_mm } 
          nameL={item.left_name} scoreL={item.left_score} claseL={item.left_class} 
          urlMomioL={patrocinadorMetadata?.left_url_mm}
          imgR={item.right_image} 
          momioR={patrocinadorMetadata?.right_mm } 
          nameR={item.right_name} scoreR={item.right_score} claseR={item.right_class} 
          urlMomioR={patrocinadorMetadata?.right_url_mm}
          urlMomioM={patrocinadorMetadata?.middle_url_mm } 
          momioM={patrocinadorMetadata?.middle_mm}
          classTeamL={item.left_class} classTeamR={item.right_class}
          urlEvento={item.opta_event_url}
          flagMomios={flagMomios}
          classGame={item.class}
        />

        {(flagMomios === 'true' || flagMomios === true) && (item.class !== "clarosports-finished-game" && item.class !== "clarosports-error-game") &&
          <FooterCardEvent 
            urlmomioEvento={patrocinadorMetadata?.url_mm_evento } 
            classPatrocinador={`buttonJuegaAqui-${patrocinador.toLowerCase()}`}
          />
        }
      </div>

    </>
  );

}
